"use client";
import Cookies from "js-cookie";
import { cookieDomain } from "@/lib/ecommerce/commercetools/client-only/cookies";
import { DefaultCookieSettings } from "@/lib/ecommerce/commercetools/client-only/constants";
import { USER_CURRENCY_COOKIE, DEFAULT_CURRENCY } from "./constants";

export const getCurrencyFromCookie = (): string => {
  if (typeof document === "undefined") return DEFAULT_CURRENCY;
  return Cookies.get(USER_CURRENCY_COOKIE) || DEFAULT_CURRENCY;
};

export const hasExplicitCurrencyChoice = (): boolean => {
  if (typeof document === "undefined") return false;
  return Boolean(Cookies.get(USER_CURRENCY_COOKIE));
};

export const setCurrencyCookie = (currency: string): void => {
  if (typeof document === "undefined") return;

  const domain = cookieDomain();
  const cookieOptions =
    window.location.hostname === "localhost"
      ? { expires: 365, ...DefaultCookieSettings }
      : { expires: 365, domain, ...DefaultCookieSettings };

  Cookies.set(USER_CURRENCY_COOKIE, currency, cookieOptions);
};
